import React, { useContext } from 'react';

import Typography from '@mui/material/Typography';

import { customFrequencyUtils } from 'app-components/flux/scheduled-transactions';
import QChoiceChips from 'components/QuickenControls/QChoiceChips';
import { FrequencyContext } from './state';

import { makeStyles } from 'tss-react/mui';

const { CHIP_DAYS } = customFrequencyUtils;

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  freqDescription: {
    paddingBottom: 8,
    fontSize: 12,
  },
  requiredFont: {
    color: theme.palette.error.main,
    paddingTop: 4,
  },
}));

const Weekly = () => {
  const { dispatch, state, error } = useContext(FrequencyContext);
  const { classes } = useStyles();

  // @ts-expect-error FIXME TS7006
  const handleDaysChange = (selectedItems) => {
    // @ts-expect-error FIXME TS7006
    const days = selectedItems?.length > 0 ? selectedItems.map((item) => item.value) : undefined;
    dispatch({ type: 'UPDATE_WEEKLY_BY_DAY', payload: days });
  };

  const selected = CHIP_DAYS.filter((item) => (state.byDay ? state.byDay.indexOf(item.value) >= 0 : false));

  return (
    <div id='weekly-recurrence' className={classes.root}>
      <Typography className={classes.freqDescription}>Select one or multiple days.</Typography>
      <QChoiceChips
        items={CHIP_DAYS}
        selectedItems={selected}
        labelFromItem={(item) => item.label}
        keyFromItem={(item) => item.value}
        multiple
        onSelected={handleDaysChange}
      />
      {error && (
        <Typography variant='captionRegular' className={classes.requiredFont}>
          At least one selection is required.
        </Typography>
      )}
    </div>
  );
};

export default Weekly;
